import moment from 'moment'

export default {
  props: [
    'finalList',
    'generalInfo',
    'fareSelected',
    'getFormatedTime',
    'removeSeconds',
    'props'
  ],
  data() {
    return {
      totalFlyTime: this.generalInfo ? this.generalInfo.flyTime : this.props.generalInfo.flyTime,
      ultimateList: this.finalList ? this.finalList : this.props.finalList,
      generalInfoStops: this.generalInfo ? this.generalInfo.stops : this.props.generalInfo.stops,
      stopsQuantity: 0,
      conectionsQuantity: 0,
      lastScroll: null,
      slider: null,
      isDown: false,
      startX: null,
      scrollLeft: null,
    }
  },
  beforeMount() {
    this.showRightArrow = this.ultimateList.length > 1;
  },
  mounted() {
    setTimeout(() => {
      this.allStopsQuantity();
    }, 0)
    this.slider = this.$refs.graphScroller;
  },
  methods: {
    totalFlyTimeString() {
      const days = moment.duration(this.totalFlyTime).days() ? `${moment.duration(this.totalFlyTime).days()}d` : '';
      const hours = moment.duration(this.totalFlyTime).hours() ? `${moment.duration(this.totalFlyTime).hours()}hs` : '';
      const min = moment.duration(this.totalFlyTime).minutes() ? `${moment.duration(this.totalFlyTime).minutes()}min` : '';
      return `${days} ${hours} ${min}`
    },
    allStopsQuantity() {
      this.ultimateList.forEach(item => {
        if (item.waitType == 'conection') {
          this.conectionsQuantity = this.conectionsQuantity + 1;
        } else if(item.waitType == 'stop') {
          this.stopsQuantity = this.stopsQuantity + 1;
        }
      })
    },
    formatMyDate(date) {
      return moment(date).format("DD-MMM-YY")
    },
    scrolling() {
      if(this.lastScroll == this.slider.scrollLeft) {
        this.showRightArrow = false;
      } else {
        this.showRightArrow = true;
      }
      this.lastScroll = this.slider.scrollLeft;
    },
    sideScroll(element,direction,speed,distance,step){
      let scrollAmount = 0;
      var slideTimer = setInterval(function(){
        element.scrollLeft += step;
        scrollAmount += step;
        if(scrollAmount >= distance){
          window.clearInterval(slideTimer);
        }
      }, speed);
      this.scrolling()
    },
    mouseDownNow(e) {
      if (this.ultimateList.length == 1) return
      this.isDown = true;
      this.slider.classList.add('active');
      this.startX = e.pageX - this.slider.offsetLeft;
      this.scrollLeft = this.slider.scrollLeft;
    },
    mouseUpNow(e) {
      if (this.ultimateList.length == 1) return
      this.isDown = false;
      this.slider.classList.remove('active');
    },
    mouseLeaveNow(e) {
      if (this.ultimateList.length == 1) return
      this.isDown = false;
      this.slider.classList.remove('active');
    },
    mouseMoveNow(e) {
      if (this.ultimateList.length == 1) return
      if(!this.isDown) return;
      e.preventDefault();
      const x = e.pageX - this.slider.offsetLeft;
      const walk = (x - this.startX); //scroll-fast
      this.slider.scrollLeft = this.scrollLeft - walk;
    }
  }
}
